import React, { FC, VFC, PropsWithChildren } from "react";
import style from "./StickyHeaderContent.scss";

export interface StickyHeaderContentProps {
    readonly header: VFC;
}

const emptyProps = {};
export const StickyHeaderContent: FC<PropsWithChildren<StickyHeaderContentProps>> = props => {
    return (
        <div className={style.stickyHeaderContent}>
            <div className={style.header}>
                {props.header(emptyProps)}
            </div>
            <div className={style.content}>
                {props.children}
            </div>
        </div>
    );
};
